 
import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main' 
import NewMain from '../headerone/newMain'




function StudentsCentreUpcomingJobOpenings() {

    return (
        <>
            <NewMain />
            <Bredcom title="Home" subtitle="Students’ Centre - Placements" />


            <section className="project-detail">
                <div className="container">
                <div className='text-center tcrctitle'>
                    <h2> Students’ Centre - Placements
                </h2>   
                </div>
                



                <div className='placementlist'>
                        <div className='row'>
                            <div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user10.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Dimple</h3>
            <h4>Department: <span>BBA</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
            <h4> Batch : <span>  2022-25 </span> </h4> 
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user11.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Shivani</h3>
            <h4>Department: <span>MBA</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
            <h4> Batch : <span>  2023-25 </span> </h4> 
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user13.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Aarti Sorout</h3>
            <h4>Department: <span>BBA</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
             <h4> Batch : <span>  2022-25</span> </h4> 
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user14.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Partha Chakraborty</h3>
            <h4>Department: <span>LAW</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
             <h4> Batch : <span>  2020-25</span> </h4> 
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user15.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Krishan Kaushik</h3>
            <h4>Department: <span>MBA</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
            <h4> Batch : <span>  2023-25</span> </h4> 
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user16.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Mohit Kumar</h3>
            <h4>Department: <span>Law</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
            <h4> Batch : <span>  2020-25</span> </h4> 
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user17.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Sapna</h3>
            <h4>Department: <span>B. Pharmacy</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
            <h4> Batch : <span>  2021-25</span> </h4> 
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/mohit_kumar01.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Mohit Kumar</h3>
            <h4>Department: <span>Law</span></h4> 
            <h4>Company Name: <span>MVN AeroOne</span></h4>
            <h4>Batch: <span>2020-25</span></h4>
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user54.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Rohan Gaur</h3>
            <h4>Department: <span>LAW</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
            <h4> Batch : <span> 2020-25</span> </h4>
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user55.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Yashika</h3>
            <h4>Department: <span>SBMC</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
            <h4> Batch : <span> 2022-25</span> </h4>
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user56.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Sangeeta Dalal</h3>
            <h4>Department: <span>SBMC</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
             <h4> Batch : <span> 2022-25</span> </h4>
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user57.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Tabitha Marie Buhion Naidu</h3>
            <h4>Department: <span>LAW</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
            <h4> Batch : <span> 2020-25</span> </h4>
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/Sachin01.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Sachin</h3>
            <h4>Department: <span>B.Tech (CSE)</span></h4>
            <h4>Company Name: <span>Bharti Airtel</span></h4>
            <h4> Batch : <span>  2020-24 </span> </h4>  
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/rakesh_sharma01.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Rakesh Sharma</h3>
            <h4>Department: <span>B.Tech (CSE)</span></h4>
            <h4>Company Name: <span>One Tick</span></h4>
            <h4> Batch : <span>  2020-24 </span> </h4> 
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/hardik_aggarwal01.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Hardik Aggarwal</h3>
            <h4>Department: <span>B. Pharmacy</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
             <h4> Batch : <span>  2023-24 </span> </h4> 
        </div>
    </div>
</div>





<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user12.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Nisha</h3>
            <h4>Department: <span>B.Com</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
            <h4> Batch : <span>  2021-24</span> </h4> 
        </div>
    </div>
</div>









<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user18.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Naresh</h3>
            <h4>Department: <span>BMLT</span></h4>
            <h4>Company Name: <span>Bohra Hospital and Medical Council</span></h4>
            <h4> Batch : <span>  2021-24</span> </h4> 
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user19.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Harender</h3>
            <h4>Department: <span>DMLT</span></h4>
            <h4>Company Name: <span>Guru Nanak Hospital</span></h4>
            <h4> Batch : <span>  2022-24</span> </h4> 
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user20.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Hritik Sherawat</h3>
            <h4>Department: <span>BMM</span></h4>
            <h4>Company Name: <span>Concentrix</span></h4>
            <h4> Batch : <span>  2023-24</span> </h4> 
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user21.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Sonam</h3>
            <h4>Department: <span>BMLT</span></h4>
             <h4>Company Name: <span>BMLT</span></h4>
             <h4> Batch : <span> 2023-24</span> </h4> 
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user25.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Vikas</h3>
            <h4>Department: <span>BMLT</span></h4>
            <h4>Company Name: <span>Modern Diagnostic center</span></h4>
            <h4> Batch : <span> 2021-24</span> </h4> 
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user26.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Prasant</h3>
            <h4>Department: <span>BMLT</span></h4>
            <h4>Company Name: <span>Modern Diagnostic center</span></h4>
            <h4> Batch : <span> 2021-24</span> </h4> 
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user28.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Manish</h3>
            <h4>Department: <span>BPT</span></h4>
            <h4>Company Name: <span>Sarvodaya</span></h4>
            <h4> Batch : <span> 2020-24</span> </h4>
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/dheeraj01.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Dheeraj</h3>
            <h4>Department: <span>M.Sc. (Micro)</span></h4>
            <h4>Company Name: <span>Medicamen Biotech Ltd</span></h4>
            <h4> Batch : <span> 2022-24</span> </h4>
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user31.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Kunal Jha</h3>
            <h4>Department: <span>BMLT</span></h4>
            <h4>Company Name: <span>Path Kind</span></h4>
            <h4> Batch : <span> 2021-24</span> </h4>
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/himanshu_pal01.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Himanshu Pal</h3>
            <h4>Department: <span>B.Sc. (Biotech)</span></h4>
            <h4>Company Name: <span>Path Kind</span></h4>
            <h4> Batch : <span> 2021-24</span> </h4>
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user48.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Mr. Devesh Sharma</h3>
            <h4>Department: <span>Pharmacy</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
            <h4> Batch : <span> 2023-24</span> </h4>
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user49.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Ms. Nitesh</h3>
            <h4>Department: <span>SBMC</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
            <h4> Batch : <span> 2021-24</span> </h4>
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/Garima01.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3> Garima</h3>
            <h4>Department: <span>M.sc Micro</span></h4>
            <h4>Company Name: <span>Jasper Food Manufacturing Pvt. Ltd.</span></h4>
            <h4> Batch : <span> 2022-24</span> </h4>
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/yash_kaushik.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Yash Kaushik</h3>
            <h4>Department: <span>Btech.CSE</span></h4>
            <h4>Company Name: <span>RARR Technology</span></h4>
            <h4> Batch : <span> 2020-24</span> </h4>
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/deepanshu_sharma.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Deepanshu Sharma</h3>
            <h4>Department: <span>Btech.CSE</span></h4>
            <h4>Company Name: <span>CarePay (Gurugram)</span></h4>
            <h4> Batch : <span> 2020-24</span> </h4>
        </div>
    </div>
</div>
                            <div className='col-md-4'>
                                <div className='onne_plcement_l'>
                                    <div className='one_palce_image'>
                                        <img src={`${process.env.PUBLIC_URL}/assets/img/new_images/placement_user01.jpg`}  />
                                    </div>

                                    <div className='one_palce_content'>
                                        <h3> Harish Aharwal </h3>
                                        <h4> Department : <span> BMLT </span> </h4>
                                        <h4> Company Name : <span>  Gov. of Haryana</span> </h4>  
                                        <h4> Batch : <span>  2020-23</span> </h4>  

                                    </div>


                                </div>
                            </div> 


<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src={`${process.env.PUBLIC_URL}/assets/img/new_images/placement_user02.jpg`}  /> 
        </div>
        <div class='one_palce_content'>
            <h3>Komal Kapoor</h3>
            <h4>Department: <span>BPT</span></h4>
            <h4>Company Name: <span>Marengo Asia Hospitals</span></h4>
            <h4> Batch : <span>  2019-23</span> </h4>  

        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
              <img src={`${process.env.PUBLIC_URL}/assets/img/new_images/navdeep_rawat01.jpg`}  />  
        </div>
        <div class='one_palce_content'>
            <h3>Navdeep Rawat</h3>
            <h4>Department: <span>B.Tech (CSE)</span></h4>
            <h4>Company Name: <span>AU Small Finance Bank</span></h4>
            <h4> Batch : <span>  2019-23 </span> </h4>  
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'> 
            <img src={`${process.env.PUBLIC_URL}/assets/img/new_images/juber_khan01.jpg`}  />  
        </div>
        <div class='one_palce_content'>
            <h3>Juber Khan</h3>
            <h4>Department: <span>M.Sc. (Micro.)</span></h4>
            <h4>Company Name: <span>Path Kind Labs</span></h4>
            <h4> Batch : <span>  2021-23 </span> </h4>  
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/Gaurang01.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Gaurang</h3>
            <h4>Department: <span>BPT</span></h4>
            <h4>Company Name: <span>CorroHealth</span></h4>
            <h4> Batch : <span>  2019-23 </span> </h4>  
        </div>
    </div>
</div>

{/** 
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user_dummy.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Kalyan Jha</h3>
            <h4>Department: <span>B.Com</span></h4>
            <h4>Company Name: <span>Arush Switchgears LLP</span></h4>
        </div>
    </div>
</div>  */}





<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user23.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Rohan Sharma</h3>
            <h4>Department: <span>BMLT</span></h4>
            <h4>Company Name: <span>Biolyst</span></h4>
            <h4> Batch : <span> 2020-23</span> </h4> 
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user24.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Jeetu</h3>
            <h4>Department: <span>BMLT</span></h4>
            <h4>Company Name: <span>Marengo Asia Hospitals</span></h4>
            <h4> Batch : <span> 2020-23</span> </h4> 
        </div>
    </div>
</div>



<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user27.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Priya</h3>
            <h4>Department: <span>M.Sc. (Micro)</span></h4>
            <h4>Company Name: <span>Medicamen Biotech Ltd</span></h4>
            <h4> Batch : <span> 2021-23</span> </h4>
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user33.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Priya Kumari</h3>
            <h4>Department: <span>BMLT</span></h4>
            <h4>Company Name: <span>MVN University</span></h4>
            <h4> Batch : <span> 2020-23</span> </h4>
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/alpana_goyal01.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Alpana Goyal</h3>
            <h4>Department: <span>BPT</span></h4>
            <h4>Company Name: <span>OPTUM</span></h4>
             <h4> Batch : <span> 2019-23</span> </h4>
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user51.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Ms. Pranjal Raghav</h3>
            <h4>Department: <span>LAW</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
            <h4> Batch : <span> 2018-23</span> </h4>
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/Preeti01.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Ms. Preeti</h3>
            <h4>Department: <span>LAW</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
            <h4> Batch : <span> 2020-23</span> </h4>
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user53.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Mr. Gourav</h3>
            <h4>Department: <span>SBMC</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
            <h4> Batch : <span> 2020-23</span> </h4>
        </div>
    </div>
</div>









<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/amrita_yadav01.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Amrita Yadav</h3>
            <h4>Department: <span>BMLT</span></h4>
            <h4>Company Name: <span>Pranjnam Complete Breast Care Center, Gurugram</span></h4>
            <h4> Batch : <span> 2020-23</span> </h4>
        </div>
    </div>
</div>






<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/chhavidutt_bhardwaj.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Chhavidutt Bhardwaj</h3>
            <h4>Department: <span>Btech.CSE</span></h4>
            <h4>Company Name: <span>CarePay (Gurugram)</span></h4>
            <h4> Batch : <span> 2019-23</span> </h4>
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user22.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Neeraj Sharma</h3>
            <h4>Department: <span>BMLT</span></h4>
            <h4>Company Name: <span>FCEM</span></h4>
            <h4> Batch : <span> 2019-22</span> </h4> 
        </div>
    </div>
</div>
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user32.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Sheetal Bholla</h3>
            <h4>Department: <span>BMM</span></h4>
            <h4>Company Name: <span>MVN University</span></h4>
            <h4> Batch : <span> 2019-22</span> </h4>
        </div>
    </div>
</div>





<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user35.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Darshan Payla</h3>
            <h4>Department: <span>BMM</span></h4>
            <h4>Company Name: <span>MVN University</span></h4>
            <h4> Batch : <span> 2019-22</span> </h4>
        </div>
    </div>
</div>
{/*
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user_dummy.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Aditya Bindal</h3>
            <h4>Department: <span>BCA</span></h4>
        </div>
    </div>
</div> 

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user_dummy.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Soniya</h3>
            <h4>Department: <span>BCA</span></h4>
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user_dummy.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Chaman</h3>
            <h4>Department: <span>B.Tech (CSE)</span></h4>
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user_dummy.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Anil</h3>
            <h4>Department: <span>B.Tech (CSE)</span></h4>
        </div>
    </div>
</div>
  
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user_dummy.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Kunsh Suneja</h3>
            <h4>Department: <span>B.Tech (CSE)</span></h4>
        </div>
    </div>
</div>

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user_dummy.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Hansi Sharma</h3>
            <h4>Department: <span>B.Tech (CSE)</span></h4>
        </div>
    </div>
</div> 

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user_dummy.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Yogesh</h3>
            <h4>Department: <span>B.Tech (CSE)</span></h4>
        </div>
    </div>
</div>  */}


{/* 
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user_dummy.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Chanchal</h3>
            <h4>Department: <span>B.Tech (CSE)</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
        </div>
    </div>
</div> 

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user_dummy.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Devesh Vats</h3>
            <h4>Department: <span>B.Tech (CSE)</span></h4>
        </div>
    </div>
</div>  

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user_dummy.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Anubhuti Mishra</h3>
            <h4>Department: <span>B.Tech (CSE)</span></h4>
        </div>
    </div>
</div> 

<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user_dummy.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Dushyant Sorout</h3>
            <h4>Department: <span>B.Tech (CSE)</span></h4>
        </div>
    </div>
</div> */}


{/* 
<div class='col-md-4'>
    <div class='onne_plcement_l'>
        <div class='one_palce_image'>
            <img src='assets/img/new_images/placement_user_dummy.jpg' />
        </div>
        <div class='one_palce_content'>
            <h3>Ms. Aeshwarya</h3>
            <h4>Department: <span>SBMC</span></h4>
            <h4>Company Name: <span>MVN AeroOne</span></h4>
        </div>
    </div>
</div> */}






                        </div>

                </div>

                     
                </div>
            </section>
        </>
    )
}

export default StudentsCentreUpcomingJobOpenings